// @ts-strict-ignore
import clsx from 'clsx'
import Link from 'next/link'

import cl from './tag.module.scss'

type DiscountItem = {
	NAME: string
	CODE: string | null
	SORT: number
	SORT_IN_CATALOG: number | null
	SHORT_NAME: string
	BACKGROUND_COLOR: string
	HIDE_ON_LIST: boolean | null
	TEXT_COLOR: string | null
	ID: number
	CUSTOM_LINK: string | null
	ACTIVE_FROM: string | null
	ACTIVE_TO: string | null
}
interface TagProps {
	tag: DiscountItem
	size?: 'S' | 'M'
}

export const Tag = (props: TagProps) => {
	const { size = 'M', tag } = props
	const { SHORT_NAME, CODE, BACKGROUND_COLOR, TEXT_COLOR } = tag

	const link = !!CODE ? CODE : null

	const styles = { backgroundColor: BACKGROUND_COLOR, color: TEXT_COLOR }

	return (
		<div className={clsx(cl.root, cl[size])} style={styles}>
			{link ? (
				<Link prefetch={false} href={link} target="_blank">
					{SHORT_NAME}
				</Link>
			) : (
				SHORT_NAME
			)}
		</div>
	)
}
